<table class="table table-striped">
  <thead>
    <tr>
      <th [style.width]="'60%'">{{ translationKey('measure.implemented') | translate }}</th>
      <th class="text-end" [innerHtml]="'businesscase.co2ConsumptionReduction' | translate"></th>
      <th class="text-end">{{ 'implementationYear' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    @for (measure of implementedMeasures(); track $index) {
      <tr>
        <td>
          {{ measure.measureName || (`measure.name.${measure.measureCode}` | translate) }}
        </td>
        <td class="text-end">{{ measure.co2ConsumptionReduction | co2: false : false : true : false }}</td>
        <td class="text-end">
          @if (measure.year) {
            {{ measure.year }}
          }
        </td>
      </tr>
    }
  </tbody>
</table>
